import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { LogoShield } from "@/components/LogoShield";

const Footer = () => {
  return (
    <footer className="bg-secondary/30 border-t border-border">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2 group">
              <LogoShield className="h-7 w-7" />
              <span className="font-heading font-bold text-xl">
                <span className="text-foreground">Shadow</span>
                <span className="text-primary">Scan</span>
              </span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Free ShadowScan Guard covers essential local hardening. Basic Hosting covers hosted onboarding, and Essential and Premium add monitored and analyst-led service levels.
            </p>
            <div className="flex items-center gap-2 text-xs font-mono text-primary/70">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              SERVICE_STATUS: LIVE
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Footer navigation">
            <h3 className="font-heading font-semibold mb-4 text-sm tracking-wider text-muted-foreground">// NAVIGATION</h3>
            <ul className="space-y-3">
                {[
                  { name: "Services", path: "/services" },
                  { name: "Free Scan", path: "/scan" },
                  { name: "About Us", path: "/about" },
                  { name: "Blog", path: "/blog" },
                  { name: "Contact", path: "/contact" },
                ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="text-primary/50 group-hover:text-primary transition-colors">→</span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Footer legal">
            <h3 className="font-heading font-semibold mb-4 text-sm tracking-wider text-muted-foreground">// LEGAL</h3>
            <ul className="space-y-3">
              {[
                { name: "Privacy Policy", path: "/privacy" },
                { name: "Terms of Service", path: "/terms" },
                { name: "Plugin Addendum", path: "/plugin-addendum" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span className="text-primary/50 group-hover:text-primary transition-colors">→</span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-semibold mb-4 text-sm tracking-wider text-muted-foreground">// CONTACT</h3>
            <ul className="space-y-4 text-sm">
              <li>
                <a 
                  href="mailto:support@shadowscan.com.au" 
                  className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group"
                >
                  <Mail className="h-4 w-4 text-primary/70 group-hover:text-primary" />
                  support@shadowscan.com.au
                </a>
              </li>
              <li>
                <a 
                  href="tel:0480465208" 
                  className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group"
                >
                  <Phone className="h-4 w-4 text-primary/70 group-hover:text-primary" />
                  0480 465 208
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground font-mono">
            © {new Date().getFullYear()} ShadowScan. All rights reserved.
          </p>
          <div className="text-xs text-muted-foreground/80 font-mono">
            Terms apply to all ShadowScan services and tools.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
